import React from 'react';
import { Play, Clock, Eye } from 'lucide-react';

const ShowCard = ({ show, onPlay }) => {
  return (
    <div 
      className="group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
      onClick={() => onPlay(show)}
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={show.thumbnail}
          alt={show.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        
        {/* Play Overlay */}
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center transform scale-75 group-hover:scale-100 transition-transform duration-300 shadow-lg">
            <Play size={28} className="text-white ml-1" fill="white" />
          </div>
        </div>

        {/* Category Badge */}
        <div className="absolute top-3 left-3">
          <span className="bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
            {show.category}
          </span>
        </div>

        {/* Duration */}
        <div className="absolute bottom-3 right-3">
          <span className="bg-black/80 text-white text-xs font-medium px-2 py-1 rounded flex items-center gap-1">
            <Clock size={12} />
            {show.duration}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 text-sm line-clamp-2 group-hover:text-red-600 transition-colors">
          {show.title}
        </h3>
        <div className="flex items-center gap-1 mt-2 text-gray-500 text-xs">
          <Eye size={14} />
          <span>{show.views} views</span>
        </div>
      </div>
    </div>
  );
};

export default ShowCard;
